import { api } from ".";
import { PROD_BASE_URL } from "../utils/constants";

export const getCountries = async () => {
  return await api.get("/crm/integration/fetchCountries");
};

export const getStates = async ({ countryToken }) => {
  return await api.get(`/crm/integration/fetchStates?country=${countryToken}`);
};


